import { proformApiQuery } from '@eliadmin/core/src/api/proform/proform-api';
import { useQuery } from '@tanstack/react-query';

export function useProductOrnament(cislo_nomenklatury: string) {
  return useQuery({
    queryKey: ['GET_PRODUCT_CONF_ORNAMENT', { cislo_nomenklatury }],
    queryFn: async () => {
      return proformApiQuery('GET_PRODUCT_CONF_ORNAMENT', {
        cislo_nomenklatury: cislo_nomenklatury,
        id_shop: 3,
      }).then(res => {
        if (!res.root.smako_conf_ornament) return null;

        if (Array.isArray(res.root.smako_conf_ornament?.ornament)) {
          return res.root.smako_conf_ornament?.ornament;
        }

        return [res.root.smako_conf_ornament?.ornament];
      });
    },
    enabled: Boolean(cislo_nomenklatury),
    retry: false,
    throwOnError: false,
  });
}
